var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","align-center":""}},[_c('img',{staticClass:"image",attrs:{"src":"/static/images/document/chat-icon.svg","alt":"Comentários"}}),_vm._v(" "),_c('span',{staticClass:"grey--text text--lighten-1"},[_vm._v("Seja o primeiro a comentar!")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755b7c14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","v-img":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/document/show/EmptyDocumentDiscussion.vue
// module id = null
// module chunks = 